import { Checkbox } from '@vouched.id/vault';
import React, { useCallback, useState } from 'react';
import { useGlobalState } from 'store/reducers/reducer';
import { updateReviewStatus } from 'store/sagas/sagas';
export const ReviewedCheckbox = ({ jobSid, jobAccountReviewed }) => {
    const { asyncDispatch } = useGlobalState();
    const [checked, setChecked] = useState(jobAccountReviewed);
    const handleCheck = useCallback(() => {
        const newChecked = !checked;
        setChecked(newChecked);
        asyncDispatch(updateReviewStatus({ id: jobSid, value: newChecked })).catch(console.error);
    }, [asyncDispatch, checked, jobSid]);
    return React.createElement(Checkbox, { checked: checked, onClick: handleCheck, variation: "small" });
};
